import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const UserDataMigrationShow: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
